import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { HistoryRouteContext } from 'src/routes'
import { MAIN_PATHS } from 'src/routes/main'
import ModalCommon from 'src/components/common/ModalCommon'

const InsufficientDiamondForHeartModal = ({ open, onClose }) => {
  const { redirectTo } = useContext(HistoryRouteContext)
  const modalButtons = [
    {
      label: 'キャンセル',
      onClick: () => onClose(),
      type: 'close'
    },
    {
      label: 'ショップへ',
      onClick: () => redirectTo(MAIN_PATHS.ShopPage)
    }
  ]

  return (
    <ModalCommon title="アイテム購入" open={open} onClose={onClose} buttons={modalButtons}>
      <div className="bg-white p-4 text-sm text-center flex flex-col gap-2">
        <p className="text-[#484848] text-[17px] font-semibold">
          ハートが不足しています。
          <br />
          ショップに移動しますか？
        </p>
        <p className="text-[#484848] text-[17px] font-semibold mt-3 mb-2">
          LIVE配信のページを離れても、配信中のカウントダウンタイマーは一時停止しません。
        </p>
        <p className="text-[#6F9BFF] text-[13px] font-medium bg-[#F8F8F8] rounded-lg p-2">
          ※Extraタイム中は特に注意が必要だコケッ!
          <br />
          ショップページからアイテムをご購入し、LIVE配信ページへ戻ってくる間にカウントダウンタイマーの残り時間が0秒になった場合、再度LIVE配信ベージに入場する事が出来なくなるコケッ！
        </p>
      </div>
    </ModalCommon>
  )
}

InsufficientDiamondForHeartModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
}

export { InsufficientDiamondForHeartModal }
